import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    background: {
      '& .MuiPaper-root': {
        backgroundColor: 'transparent',
      },
      '& .MuiBackdrop-root': {
        cursor: 'pointer',
      },
    },
  }),
);

export default useStyles;
